import { CCard, CCardBody, CCol, CFormTextarea, CPopover, CProgress, CRow } from '@coreui/react-pro'
import React, { useState, useEffect, useRef } from 'react'
import './MessageThread.scss'
import { useDispatch, useSelector } from 'react-redux'
import { getChatMessages, getContactList, getMessageList } from 'src/redux/messages/messageThunk'
import { setMessages } from 'src/redux/messages/messageSlice'
import moment from 'moment'
import Loader from 'src/components/common/Loader/Loader'
import MessageFileUpload from './MessageFileUpload'
import { AiOutlineClose } from 'react-icons/ai'
import { format } from 'date-fns'
import {
  createConversation,
  downloadFile,
  getPicture,
  setStatus,
  setChargeClaimStatus,
  updateArchiveStatus,
} from 'src/helper/backendHelper'
import { socket } from 'src/socket'
import { dateWithTime } from 'src/utils/dateTimeUtils'
import { AllowedFormats } from '../../../utils/sharedAttachmentFunctions'

import MicRecorder from 'mic-recorder-to-mp3'
import axios from 'axios'
import { setupInterceptorsTo, SOCKET_URL } from 'src/apiHelper/helper.js'
import { BsFillPauseCircleFill, BsFillPlayCircleFill } from 'react-icons/bs'
import Logo from '../../../assets/Logo.svg'
import AILogo from 'src/assets/BlueLogo.svg'
import { randomString, convertHyphenDateToSlashDate } from '../../../utils/sharedFunctions'
import { GRAY_300 } from '../../../scss/colorConsts'
import { toast } from 'react-toastify'
import { getIsAi } from '../../../utils/sharedFeaturesFunctions'
import { VISIT_STATUS } from '../../../utils/statusConstants'
import { TASK_STATUSES } from '../../../utils/taskConstants'

const Mp3Recorder = new MicRecorder({ bitRate: 128 })
const socketApi = setupInterceptorsTo(
  axios.create({
    baseURL: SOCKET_URL,
  }),
)
const MessageThread = ({ text, setText }) => {
  const ref = useRef(null)
  const fileInput = useRef(null)
  const dispatch = useDispatch()
  const [files, setFiles] = useState([])
  const [fileUpload, setFileUpload] = useState(false)
  const activeTab = useSelector((state) => state.messages?.activeTab)
  const selectedChat = useSelector((state) => state.messages?.selectedChat)
  const messages = useSelector((state) => state.messages?.messages)
  const [isLoading, setIsLoading] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [msgCopy, setMsgCopy] = useState(messages)
  const currentUser = useSelector((state) => state.user)
  const currentUserId = currentUser?.user?._id
  const [isRecording, setIsRecording] = useState(false)
  const [blobURL, setBlobURL] = useState('')
  const [isBlocked, setIsBlocked] = useState(false)

  const selectedProvider = useSelector((state) => state.user?.provider)

  const handleInput = (e) => {
    if (ref.current) {
      ref.current.style.height = 'auto'
      ref.current.style.height = `${e.target.scrollHeight - 16}px`
    }
    setText(e.target.value)
  }

  const getContactLists = async () => {
    await dispatch(getContactList({}))
  }

  // Now getUserMedia Supports all browsers
  // Added navigator.mediaDevices.getUserMedia is for safari browser
  navigator.getUserMedia =
    navigator.getUserMedia ||
    navigator.webkitGetUserMedia ||
    navigator.mozGetUserMedia ||
    navigator.mediaDevices.getUserMedia

  useEffect(() => {
    navigator.getUserMedia(
      { audio: true },
      () => {
        console.log('Permission Granted')
        setIsBlocked(false)
      },
      () => {
        console.log('Permission Denied')
        setIsBlocked(true)
      },
    )
    getContactLists()
  }, [])

  const getMessages = async (conversationId) => {
    setIsLoading(true)
    if (conversationId?._id === undefined) {
      return
    }
    let res = await dispatch(getChatMessages(conversationId))

    if (res?.payload?.status === 'success') {
      res.data = res?.payload?.data
      if (res?.data?.length === 0 && Object.keys(selectedChat)?.length > 0) {
        let payload = [
          {
            _id: conversationId?.id,
            participantss: JSON.parse(JSON.stringify(selectedChat?.participants)),
          },
        ]
        for (let i = 0; i < payload[0]?.participantss?.length; i++) {
          let participant = payload[0]?.participantss[i]
          if (participant?.username || participant?.displayname) {
            if (!participant?.username) {
              participant.username = participant?.displayname
            }
            if (participant?.username.indexOf(' ') === -1) {
              participant.username_character = participant?.username?.charAt(0).toUpperCase()
            } else {
              let x = participant?.username.substr(participant?.username?.indexOf(' ') + 1)
              participant.username_character =
                participant?.username?.charAt(0).toUpperCase() + x.charAt(0).toUpperCase()
            }
          }
          if (participant?.practice_visibility === false) {
            participant.pv = 'assets/imgs/avatar-claimocity.png'
          }
        }
        for (let i = 0; i < res?.data[0]?.messagess?.length; i++) {
          if (
            res?.data[0]?.messagess[i]?.message_type === 2 ||
            res?.data[0]?.messagess[i]?.message_type === 3
          ) {
            if (res?.data[0]?.messagess[i]?.file_name?.length > 0) {
              try {
                let result = await getPicture(res?.data[0]?.messagess[i]?.file_name)
                res.data[0].messagess[i]['fileurl'] = result?.data
                res.data[0].messagess[i]['play'] = false
              } catch (err) {}
            }
          }
        }

        setMsgCopy(payload)
        await dispatch(setMessages(payload))
      } else {
        setMsgCopy(res?.data)
        await dispatch(setMessages(res?.data))
      }
    }
    setIsLoading(false)
    setTimeout(() => {
      scrollDown()
    }, 500)
  }

  const getMessagesList = async (conversationId) => {
    if (conversationId?._id === undefined) {
      return
    }
    let res = await dispatch(getChatMessages(conversationId))

    if (res?.payload?.status === 'success') {
      res.data = res?.payload?.data
      if (res?.data?.length === 0 && Object.keys(selectedChat)?.length > 0) {
        let payload = [
          {
            _id: conversationId?.id,
            participantss: JSON.parse(JSON.stringify(selectedChat?.participants)),
          },
        ]
        for (let i = 0; i < payload[0]?.participantss?.length; i++) {
          let participant = payload[0]?.participantss[i]
          if (participant?.username || participant?.displayname) {
            if (!participant?.username) {
              participant.username = participant?.displayname
            }
            if (participant?.username.indexOf(' ') === -1) {
              participant.username_character = participant?.username?.charAt(0).toUpperCase()
            } else {
              let x = participant?.username.substr(participant?.username?.indexOf(' ') + 1)
              participant.username_character =
                participant?.username?.charAt(0).toUpperCase() + x.charAt(0).toUpperCase()
            }
          }
          if (participant?.practice_visibility === false) {
            participant.pv = 'assets/imgs/avatar-claimocity.png'
          }
        }
        for (let i = 0; i < res?.data[0]?.messagess?.length; i++) {
          if (
            res?.data[0]?.messagess[i]?.message_type === 2 ||
            res?.data[0]?.messagess[i]?.message_type === 3
          ) {
            if (res?.data[0]?.messagess[i]?.file_name?.length > 0) {
              try {
                let result = await getPicture(res?.data[0]?.messagess[i]?.file_name)
                res.data[0].messagess[i]['fileurl'] = result?.data
                res.data[0].messagess[i]['play'] = false
              } catch (err) {}
            }
          }
        }

        setMsgCopy(payload)
        await dispatch(setMessages(payload))
      } else {
        setMsgCopy(res?.data)
        await dispatch(setMessages(res?.data))
      }
    }
    setTimeout(() => {
      scrollDown()
    }, 500)
  }

  useEffect(() => {
    if (Object?.keys(selectedChat)?.length > 0) {
      if (selectedChat?._id) getMessages(selectedChat)
    }
  }, [selectedChat])

  useEffect(() => {
    setSearchText('')
  }, [files])

  const removeImage = (key) => {
    setFiles(files.filter((file) => file?.key !== key))
  }

  const sendMessage = async () => {
    if (files?.length === 0 && text?.length > 0) {
      let body = {
        user_id: currentUserId,
        conversation_id: selectedChat?._id,
        message_type: 1,
        message_text: text,
        is_internal: false,
      }

      let res = await createConversation(selectedChat?._id, body)

      if (res) {
        setText('')
        socket.emit('new_message', {
          conversation_id: selectedChat?._id,
          count_msg: 'last_msg',
          user_id: currentUserId,
        })
      }
    } else {
      for (let i = 0; i < files?.length; i++) {
        if (files[i]?.message_type === 3) {
          let body = {
            user_id: currentUserId,
            conversation_id: selectedChat?._id,
            message_type: 3,
            file_name: files[i]?.file?.name,
            is_internal: false,
          }
          let res = await createConversation(selectedChat?._id, body)
        } else if (files[i]?.message_type === 2) {
          let body = {
            user_id: currentUserId,
            conversation_id: selectedChat?._id,
            message_type: 2,
            file_name: files[i]?.file?.name,
            is_internal: false,
          }
          let res = await createConversation(selectedChat?._id, body)
        }
      }
      getMessagesList(selectedChat)
      let data = {
        q: '',
        page: 0,
        type:
          activeTab?.selected === 'Provider Hold'
            ? 'messages'
            : activeTab?.selected === 'Archived'
              ? 'archive'
              : '',
        tab: activeTab?.selected,
      }
      let messageListRes = await dispatch(getMessageList(data))
      setFiles([])
    }
    if (activeTab?.selected === 'Provider Hold') {
      let req = {
        id: selectedChat?._id,
        status: 'archive',
      }

      let res = await updateArchiveStatus(req)
      if (res) {
        activeTab.tabs.forEach((item) => {
          dispatch(
            getMessageList({
              q: searchText,
              page: 0,
              type:
                item.name === 'Provider Hold'
                  ? 'messages'
                  : item.name === 'Archived'
                    ? 'archive'
                    : '',
              tab: item?.name,
            }),
          )
        })
      }
    }
    if (selectedChat?.taskstatus_id === TASK_STATUSES.PROVIDER_HOLD) {
      let data = {
        charge_id: selectedChat?.charge_id,
        newStatus: TASK_STATUSES.RESPONSE_RECEIVED,
        parentStatus: 'Provider Hold',
        parent_assigned_userid: currentUserId,
        status: 'Response Received',
        taskid: selectedChat?.task_id,
      }
      let statusRes = await setStatus(data, selectedChat?.task_id)
      if (statusRes?.status === 'success') {
        let chargeData = {
          charge_ids: [selectedChat?.charge_id],
          newStatus: VISIT_STATUS.bill_submitted,
        }
        let chargeClaimStatus = await setChargeClaimStatus(chargeData)
        if (chargeClaimStatus?.status === 'success') {
          setText('')
        }
      }
    }
  }

  useEffect(() => {
    socket.connect()
    socket.emit('join-room', selectedChat?._id)
  }, [selectedChat?._id])

  const showRecentMessage = async (data, msg) => {
    let messagesData = JSON.parse(JSON.stringify(msg))
    if (messagesData[0]?.messagess?.length === 0 || messagesData[0]?.messagess === undefined) {
      messagesData[0].messagess = []
    }

    if (
      data?.data &&
      data?.data?.data[0] &&
      data?.data?.data[0]?._id &&
      messagesData[0]?._id == data?.data?.data[0]?._id
    ) {
      if (
        data?.count_msg == 'second_last_msg' &&
        data?.data?.data[0]?.second_last_message &&
        data?.data?.data[0]?.last_message
      ) {
        // socket binding second last message
        try {
          let second_last_msg = data?.data?.data[0]?.second_last_message
          second_last_msg.username = data?.data?.data[0]?.username
          messagesData[0]?.messagess?.push(second_last_msg)
          // socket binding last message
          let latestmsg = data?.data?.data[0]?.last_message
          latestmsg.username = data?.data?.data[0]?.username
          messagesData[0]?.messagess?.push(latestmsg)
        } catch (err) {
          console.log(err)
        }
      } else if (data?.count_msg == 'last_msg' && data?.data?.data[0]?.last_message) {
        // socket binding last message
        try {
          let latestmsg = data?.data?.data[0]?.last_message
          latestmsg.username = data?.data?.data[0]?.username
          messagesData[0]?.messagess?.push(latestmsg)
        } catch (err) {
          console.log(err)
        }
      }

      for (let i = 0; i < messagesData[0]?.messagess?.length; i++) {
        // Getting Image from s3
        if (
          (messagesData[0]?.messagess[i]?.message_type == 2 ||
            messagesData[0]?.messagess[i]?.message_type == 3) &&
          messagesData[0]?.messagess[i]?.file_name != null &&
          messagesData[0]?.messagess[i]?.file_name != undefined
        ) {
          let tmp = messagesData[0]?.messagess[i]?.file_name
          try {
            let res = await getPicture(messagesData[0]?.messagess[i]?.file_name)
            if (res.status == 'success') {
              messagesData[0].messagess[i]['fileurl'] = res?.data
              messagesData[0].messagess[i]['play'] = false
            }
          } catch (err) {}
        } else if (messagesData[0]?.messagess[i]?.message_type == 1) {
          setTimeout(() => {
            scrollDown()
          }, 800)
        }
        // Checking the same time of messages
        if (i > 0) {
          if (
            new Date(messagesData[0]?.messagess[i]?.message_datetime).getFullYear() ==
              new Date(messagesData[0]?.messagess[i - 1]?.message_datetime).getFullYear() &&
            new Date(messagesData[0]?.messagess[i]?.message_datetime).getMonth() + 1 ==
              new Date(messagesData[0]?.messagess[i - 1]?.message_datetime).getMonth() + 1 &&
            new Date(messagesData[0]?.messagess[i]?.message_datetime).getDate() ==
              new Date(messagesData[0]?.messagess[i - 1]?.message_datetime).getDate() &&
            new Date(messagesData[0]?.messagess[i]?.message_datetime).getHours() ==
              new Date(messagesData[0]?.messagess[i - 1]?.message_datetime).getHours() &&
            new Date(messagesData[0]?.messagess[i]?.message_datetime).getMinutes() ==
              new Date(messagesData[0]?.messagess[i - 1]?.message_datetime).getMinutes()
          ) {
            messagesData[0].messagess[i]['sameTime'] = 'true'
          }
        }
      }

      await dispatch(setMessages(messagesData))
      setMsgCopy(messagesData)
      let listingPayload = {
        q: '',
        page: 0,
        type:
          activeTab?.selected === 'Provider Hold'
            ? 'messages'
            : activeTab?.selected === 'Archived'
              ? 'archive'
              : '',
        tab: activeTab?.selected,
      }
      dispatch(getMessageList(listingPayload))
    }
  }

  useEffect(() => {
    socket.on('recent_message', (data) => {
      // TODO can this be deleted?
      setMsgCopy((prevState) => {
        data.data.data.forEach(function (item) {
          if (item.last_message.message_type == 3) {
            item.last_message['playPauseAudio'] = false
          }
        })

        showRecentMessage(data, prevState)
      })
    })

    return () => {
      socket.off('recent_message')
    }
  }, [socket])

  const start = () => {
    if (isBlocked) {
      console.log('Permission Denied')
    } else {
      Mp3Recorder.start()
        .then(() => {
          setIsRecording(true)
        })
        .catch((e) => console.error(e))
    }
  }

  const uploadImage = (file, fileName) => {
    const reader = new FileReader()
    let fileExt = file?.name?.split('.')?.pop()
    if (!AllowedFormats.includes(fileExt)) {
      toast.error('File type is not supported.')
    } else {
      reader.readAsDataURL(file)
      reader.onloadend = async (e) => {
        let cameraImage = {
          key: fileName, //file.name,
          size: file.size,
          file_type: fileExt,
          checksum: null,
          file: file,
          img: reader.result,
          //TODO
          status: 'uploading',
        }
        setFiles([...files, cameraImage])

        let formData = new FormData()
        formData.append('file', file)
        formData.append('fileName', fileName)

        const response = await socketApi.post('/conversations/upload/file', formData)

        if (response?.data?.status === 'success') {
          setFiles([...files, { ...cameraImage, status: 'uploaded', message_type: 3 }])
        } else {
          toast.error('Upload failed.  Please try again.')
        }
      }
    }
  }

  const stop = () => {
    Mp3Recorder.stop()
      .getMp3()
      .then(([buffer, blob]) => {
        const bloburl = URL.createObjectURL(blob)
        setBlobURL(bloburl)
        setIsRecording(false)
        let fileName = selectedProvider?._id + '_' + new Date().getTime() + randomString(6) + '.mp3'
        const file = new File(buffer, fileName, {
          type: blob.type,
          lastModified: Date.now(),
        })
        uploadImage(file, fileName)
      })
      .catch((e) => console.log(e))
  }

  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  const togglePlay = async (i) => {
    let myAudio = document.getElementById('myAudio' + i)
    myAudio?.play()
  }

  const downloadImage = async (fileName) => {
    let res = await downloadFile(fileName).then((response) => {
      const link = document.createElement('a')
      link.href = response
      link.setAttribute('download', fileName) //or any other extension
      document.body.appendChild(link)
      link.click()
    })
  }

  const scrollDown = () => {
    const box = document.getElementById('message-thread-list')
    if (box) {
      box.scrollTop = 999999999
    }
  }

  let messagesTitle = messages[0]?.title
  let titleEnd = messagesTitle?.length - 10 || 0
  let titleDate = messagesTitle?.slice(titleEnd)

  return (
    <CCard className="message-thread">
      {isLoading && <Loader />}
      <CCardBody className="message-thread-body">
        <div className="message-thread-container">
          <CRow>
            <h4 className="messages-title">
              {messagesTitle?.slice(0, titleEnd)} {convertHyphenDateToSlashDate(titleDate)}
            </h4>
            <div className="messages-participants">
              {messages &&
                messages[0]?._id &&
                messages[0]?.participantss
                  ?.map((items, i) => capitalizeFirst(items?.username))
                  ?.join(', ')}
            </div>
            <div
              id="message-thread-list"
              className={`message-thread-list ${(files?.length > 0 || isRecording) && 'files'}`}
            >
              {messages?.length > 0 &&
                messages[0]?.messagess?.map((item, idx) => {
                  return (
                    item?.is_internal === false && (
                      <div key={idx} className="thread-container">
                        <div className="msgleft">
                          {selectedChat?.participants[
                            selectedChat?.participants?.findIndex(
                              (p) => p?.user_id === item?.user_id,
                            )
                          ]?.showIcon === false ? (
                            <span>
                              {
                                selectedChat?.participants[
                                  selectedChat?.participants?.findIndex(
                                    (p) => p?.user_id === item?.user_id,
                                  )
                                ]?.displayInitials
                              }
                            </span>
                          ) : (
                            <img src={getIsAi() ? AILogo : Logo} alt="Claimocity Logo" />
                          )}
                          <div></div>
                        </div>
                        <div className="msgright">
                          <div className="msgtop">
                            <div className="msg-left">
                              <span>{item?.username}</span>
                            </div>
                            <div className="msg-right">
                              <span>{dateWithTime(item?.message_datetime)}</span>
                            </div>
                          </div>
                          <div className="msgbottom">
                            <span>
                              {item?.message_type === 1 ? (
                                item?.message_text
                              ) : item?.message_type === 3 ? (
                                <div className="audioFile">
                                  <p
                                    className="title"
                                    onClick={(e) => {
                                      togglePlay(idx)
                                    }}
                                  >
                                    {item?.playPauseAudio === false ? (
                                      <BsFillPlayCircleFill />
                                    ) : (
                                      <BsFillPlayCircleFill />
                                    )}{' '}
                                    Voice Message
                                  </p>
                                  <p className="date">
                                    {moment(item?.message_datetime).format('MM/DD/YYYY')}
                                  </p>
                                  <p className="date">Created by {item?.username}</p>
                                  <audio id={`myAudio${idx}`} src={item?.fileurl} preload="auto" />
                                </div>
                              ) : (
                                <div className="audioFile">
                                  <p
                                    className="title"
                                    onClick={(e) => {
                                      downloadImage(item?.file_name)
                                    }}
                                  >
                                    {item?.file_name}
                                  </p>
                                  <p className="date">
                                    {moment(item?.message_datetime).format('MM/DD/YYYY')}
                                  </p>
                                  <p className="date">Created by {item?.username}</p>
                                  <audio id={`myAudio${idx}`} src={item?.fileurl} preload="auto" />
                                </div>
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    )
                  )
                })}
            </div>
          </CRow>
        </div>

        {(messages?.length === 0 || messages[0]?.messagess?.length === 0) && (
          <div className="noMsgContainer">
            <i className="fa-regular fa-envelope" style={{ fontSize: '10em' }}></i>
            <span className="title">No messages</span>
            <span className="desc">Start a conversation to see messages here</span>
          </div>
        )}
        <div
          className={`MessageThread-bottom-div-align ${
            Object.keys(selectedChat)?.length == 0 ? 'nomessage' : ''
          }`}
        >
          {Object.keys(selectedChat)?.length > 0 && (
            <CRow className="form-message">
              <CCol>
                <CFormTextarea
                  ref={ref}
                  rows={1}
                  placeholder="Type something..."
                  onInput={handleInput}
                  value={text}
                  disabled={files?.length > 0}
                  onKeyDown={(e) => {
                    if (e?.keyCode === 13) {
                      e?.preventDefault()
                      if (text?.length > 0) {
                        sendMessage()
                      }
                    }
                  }}
                />
                <audio id={`myAudio`} src={blobURL} preload="auto" />
                {files?.length > 0 && isRecording === false && (
                  <div
                    className={files?.length > 0 ? 'messagethread-files' : 'messagethread-noFile'}
                  >
                    {files?.map((item, i) =>
                      item?.status === 'uploaded' ? (
                        <div className="messagethread-fileupload-files" key={i}>
                          <div className="mid">
                            <p
                              className="up"
                              onClick={(e) => {
                                togglePlay('')
                              }}
                            >
                              {item?.message_type === 3 && (
                                <BsFillPlayCircleFill className="playIcon" />
                              )}
                              {item?.message_type === 3
                                ? 'Voice message is done'
                                : !item?.file?.name
                                  ? item?.name
                                  : item?.file?.name}
                            </p>
                            <p className="down">{format(new Date(), 'MM/dd/yyyy')}</p>
                            <p className="down">Created by {currentUser?.user?.displayname}</p>
                          </div>
                          <div
                            className="right"
                            onClick={(e) => {
                              removeImage(item?.key)
                            }}
                          >
                            <AiOutlineClose className="close" />
                          </div>
                        </div>
                      ) : (
                        <div className="meassagethread-filesUploading" key={i}>
                          <div className="right">
                            <div className="up">
                              <p className="info">
                                {!item?.file?.name ? item?.name : item?.file?.name}
                              </p>
                            </div>
                            <div className="down">
                              <CProgress thin value={10} className="progress" />
                            </div>
                          </div>
                        </div>
                      ),
                    )}
                  </div>
                )}
                {isRecording && (
                  <div className="messagethread-files" onClick={() => stop()}>
                    <div className="messagethread-fileupload-files">
                      <div className="mid">
                        <p className="up">
                          <BsFillPauseCircleFill className="playIcon green" />
                          Voice message in progress
                        </p>
                      </div>
                      <div className="right">
                        <AiOutlineClose className="close" />
                      </div>
                    </div>
                  </div>
                )}
                <div className="messagethread-bottom-icons">
                  <div>
                    <span className="messagethread-plus-design">
                      <CPopover content="Upload file" placement="top" trigger="hover">
                        <i
                          className="fa-solid fa-circle-plus"
                          style={{ color: GRAY_300, fontSize: '1.8em' }}
                          onClick={() => {
                            setFileUpload(true)
                            fileInput.current?.click()
                          }}
                        ></i>
                      </CPopover>
                    </span>
                  </div>
                  <div
                    className="messagethread-send-icon"
                    onClick={() => {
                      sendMessage()
                    }}
                  >
                    <i
                      className={`fa-solid fa-paper-plane-top ${
                        text.length > 0 || files.length > 0 ? 'enabled' : ''
                      }`}
                    ></i>
                  </div>
                </div>
              </CCol>
            </CRow>
          )}
        </div>
      </CCardBody>
      <MessageFileUpload
        visible={fileUpload}
        files={files}
        setFiles={setFiles}
        fileInput={fileInput}
      />
    </CCard>
  )
}

export default MessageThread
